import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import femaleLoaderJson from '@/data/lottie-animations/femaleLoader.json'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingLottieAnimation', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: ({ $t }): LandingComponentsConfig['LandingTitle'] => ({
			title: $t('pages.landing.male_funnel.title'),
			size: 'small',
		}),

		LandingLottieAnimation: (): LandingComponentsConfig['LandingLottieAnimation'] => ({
			animationData: femaleLoaderJson,
			loop: false,
			customStyles: {
				height: '50vh',
				marginTop: 'var(--size-18)',
				marginBottom: 'var(--size-18)',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
